import {reactive} from 'vue'

let globalState = reactive({
  dragging: false
})


export {globalState}